import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "font-semi-bold font-size-12" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "p-2" }
const _hoisted_6 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "font-semi-bold font-size-12" }
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = {
  class: "row",
  id: "contactsDiv"
}
const _hoisted_13 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_financialSituation_nature"
}
const _hoisted_14 = { class: "d-block mb-0 small text-muted" }
const _hoisted_15 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_financialSituation_amount"
}
const _hoisted_16 = { class: "d-block mb-0 small text-muted" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_19 = { class: "d-block mb-0 small text-muted" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "flex-grow-1" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_financialSituation_label"
}
const _hoisted_26 = { class: "d-block mb-0 small text-muted" }
const _hoisted_27 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_28 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_financialSituation_country"
}
const _hoisted_29 = { class: "d-block mb-0 small text-muted" }
const _hoisted_30 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_31 = { class: "d-block mb-0 small text-muted" }
const _hoisted_32 = { class: "row items-center justify-end" }
const _hoisted_33 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_34 = { class: "d-block mb-0 small text-muted" }
const _hoisted_35 = { class: "row items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_form = _resolveComponent("q-form")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_expansion_item, {
            modelValue: _ctx.showFinancialSituationExpense,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showFinancialSituationExpense) = $event)),
            "switch-toggle-side": "",
            "header-class": "card-header bg-transparent no-border p-4",
            class: "card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group",
            onShow: _cache[2] || (_cache[2] = ($event: any) => {
          _ctx.financialSituationBtn = !_ctx.financialSituationBtn;
          _ctx.addExpandedBalanceSheet(_ctx.balanceSheets);
        }),
            onHide: _cache[3] || (_cache[3] = ($event: any) => {
          _ctx.financialSituationBtn = !_ctx.financialSituationBtn;
          _ctx.removeExpandedItem(_ctx.balanceSheets);
        })
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("middleOffice.party.organization.section.financialSituation")), 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.balanceSheetsList, (value, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "p-2 bg-white default-border-radius mb-3",
                    key: index
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_q_expansion_item, {
                          "switch-toggle-side": "",
                          "header-class": "card-header bg-transparent no-border p-4",
                          modelValue: _ctx.detailsOpened,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detailsOpened) = $event)),
                          class: "card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group",
                          onShow: ($event: any) => {
                  _ctx.balanceSheetItemPlusBtn = !_ctx.balanceSheetItemPlusBtn;
                  _ctx.showHideDetails(value);
                },
                          onHide: ($event: any) => {
                  _ctx.balanceSheetItemPlusBtn = !_ctx.balanceSheetItemPlusBtn;
                  _ctx.removeExpandedItem(value.detail);
                }
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("middleOffice.party.organization.section.detail")), 1)
                              ])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.detail, (detail, detailIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "p-2 bg-white default-border-radius mb-3",
                                  key: detailIndex
                                }, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("middleOffice.party.organization.financialSituation.nature")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": "third_edit_financialSituation_nature",
                                            dense: "",
                                            outlined: "",
                                            "model-value": _ctx.getNatureLabel(detail, detailIndex),
                                            disable: ""
                                          }, null, 8, ["model-value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                          _createElementVNode("label", _hoisted_16, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("middleOffice.party.organization.financialSituation.amount")), 1),
                                            (!_ctx.isPartPro)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*"))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createVNode(_component_q_input, {
                                            "data-testid": "third_edit_financialSituation_amount",
                                            dense: "",
                                            outlined: "",
                                            type: "number",
                                            modelValue: detail.value.amount,
                                            "onUpdate:modelValue": ($event: any) => ((detail.value.amount) = $event),
                                            disable: _ctx.isMO,
                                            rules: [(val) => !!val || _ctx.requiredField]
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disable", "rules"])
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("label", _hoisted_19, [
                                            _createTextVNode(_toDisplayString(_ctx.getDetailDateLabel(detail, detailIndex)) + " ", 1),
                                            (_ctx.isBilanDateRequired(detail, detailIndex))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "*"))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "model-value": _ctx.formatDisplayDate(detail.label),
                                            "onUpdate:modelValue": (val) => _ctx.updateDate(val, detail),
                                            disable: _ctx.isMO,
                                            mask: "## / ####",
                                            placeholder: "MM / YYYY",
                                            rules: _ctx.isBilanDateRequired(detail, detailIndex) ? [(val) => !!_ctx.formatDisplayDate(detail.label) || _ctx.requiredField] : []
                                          }, null, 8, ["model-value", "onUpdate:modelValue", "disable", "rules"])
                                        ])
                                      ])
                                    ]),
                                    (detailIndex > 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                          _createVNode(_component_q_btn, {
                                            outline: "",
                                            class: "btn btn-outline-danger mt-3",
                                            icon: "delete",
                                            onClick: ($event: any) => (_ctx.removeDetails(detailIndex, value.detail)),
                                            disable: _ctx.isMO
                                          }, null, 8, ["onClick", "disable"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onShow", "onHide"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("label", _hoisted_26, [
                                _createTextVNode(_toDisplayString(_ctx.$t("middleOffice.party.organization.financialSituation.employeeNumber")), 1),
                                (!_ctx.isPartPro)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_financialSituation_label",
                                dense: "",
                                outlined: "",
                                modelValue: value.label,
                                "onUpdate:modelValue": ($event: any) => ((value.label) = $event),
                                disable: _ctx.isMO,
                                type: "number"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disable"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.country")), 1),
                              _createVNode(_component_q_select, {
                                "data-testid": "third_edit_financialSituation_country",
                                dense: "",
                                outlined: "",
                                modelValue: value.country,
                                "onUpdate:modelValue": ($event: any) => ((value.country) = $event),
                                options: _ctx.countriesOptions,
                                disable: _ctx.isMO
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disable"])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("main.labels.startDate")), 1),
                              _createVNode(_component_q_input, {
                                readonly: "",
                                onChange: ($event: any) => (_ctx.formatDateFrom(value)),
                                dense: "",
                                outlined: "",
                                modelValue: value.period.from,
                                "onUpdate:modelValue": ($event: any) => ((value.period.from) = $event),
                                disable: _ctx.isMO
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "event",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref_for: true,
                                        ref: "qDateProxy",
                                        cover: "",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_date, {
                                            modelValue: value.period.from,
                                            "onUpdate:modelValue": ($event: any) => ((value.period.from) = $event),
                                            mask: _ctx.dateMask,
                                            options: 
                                  (date) =>
                                    value.period.until
                                      ? date < _ctx.formatDate(value.period.until)
                                      : true
                                
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_32, [
                                                _withDirectives(_createVNode(_component_q_btn, {
                                                  label: _ctx.$t('task.completeDocument.party.person.financialSituation.close'),
                                                  color: "primary",
                                                  flat: ""
                                                }, null, 8, ["label"]), [
                                                  [_directive_close_popup]
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "onUpdate:modelValue", "mask", "options"])
                                        ]),
                                        _: 2
                                      }, 1536)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onChange", "modelValue", "onUpdate:modelValue", "disable"])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("main.labels.endDate")), 1),
                              _createVNode(_component_q_input, {
                                readonly: "",
                                onChange: ($event: any) => (_ctx.formatDateUntil(value)),
                                dense: "",
                                outlined: "",
                                modelValue: value.period.until,
                                "onUpdate:modelValue": ($event: any) => ((value.period.until) = $event),
                                disable: _ctx.isMO
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "event",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref_for: true,
                                        ref: "qDateProxy",
                                        cover: "",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_date, {
                                            modelValue: value.period.until,
                                            "onUpdate:modelValue": ($event: any) => ((value.period.until) = $event),
                                            mask: _ctx.dateMask,
                                            options: 
                                  (date) =>
                                    value.period.from
                                      ? date > _ctx.formatDate(value.period.from)
                                      : true
                                
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_35, [
                                                _withDirectives(_createVNode(_component_q_btn, {
                                                  label: _ctx.$t('task.completeDocument.party.person.financialSituation.close'),
                                                  color: "primary",
                                                  flat: ""
                                                }, null, 8, ["label"]), [
                                                  [_directive_close_popup]
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "onUpdate:modelValue", "mask", "options"])
                                        ]),
                                        _: 2
                                      }, 1536)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onChange", "modelValue", "onUpdate:modelValue", "disable"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_q_btn, {
                            outline: "",
                            class: "btn btn-outline-danger mt-4",
                            icon: "delete",
                            onClick: ($event: any) => (_ctx.remove(index, _ctx.balanceSheets)),
                            disable: _ctx.isMO
                          }, null, 8, ["onClick", "disable"])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}